// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/pc/landing_info.proto (package qliq_protobuf.apps.pc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ChatProps } from "./chat_props_pb.ts";
import { PeerProps } from "../../auth/peer_props_pb.ts";
import { AuthStrategy } from "./auth_strategy_pb.ts";
import { AuthSecretRoute } from "./auth_secret_route_pb.ts";
import { ApiErrorCode } from "../../api_error_code_pb.ts";
import { Session } from "../../auth/session_pb.ts";

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo
 */
export class LandingInfo extends Message<LandingInfo> {
  /**
   * @generated from field: qliq_protobuf.apps.pc.ChatProps chat_props = 1;
   */
  chatProps?: ChatProps;

  /**
   * @generated from field: qliq_protobuf.auth.PeerProps peer_props = 2;
   */
  peerProps?: PeerProps;

  /**
   * @generated from oneof qliq_protobuf.apps.pc.LandingInfo.landing_state
   */
  landingState: {
    /**
     * @generated from field: qliq_protobuf.apps.pc.LandingInfo.AuthRequest auth_request = 3;
     */
    value: LandingInfo_AuthRequest;
    case: "authRequest";
  } | {
    /**
     * @generated from field: qliq_protobuf.apps.pc.LandingInfo.AuthInfo auth_info = 4;
     */
    value: LandingInfo_AuthInfo;
    case: "authInfo";
  } | {
    /**
     * @generated from field: qliq_protobuf.apps.pc.LandingInfo.ErrorInfo landing_error_info = 5;
     */
    value: LandingInfo_ErrorInfo;
    case: "landingErrorInfo";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<LandingInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chat_props", kind: "message", T: ChatProps },
    { no: 2, name: "peer_props", kind: "message", T: PeerProps },
    { no: 3, name: "auth_request", kind: "message", T: LandingInfo_AuthRequest, oneof: "landing_state" },
    { no: 4, name: "auth_info", kind: "message", T: LandingInfo_AuthInfo, oneof: "landing_state" },
    { no: 5, name: "landing_error_info", kind: "message", T: LandingInfo_ErrorInfo, oneof: "landing_state" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo {
    return new LandingInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo {
    return new LandingInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo {
    return new LandingInfo().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo | PlainMessage<LandingInfo> | undefined, b: LandingInfo | PlainMessage<LandingInfo> | undefined): boolean {
    return proto3.util.equals(LandingInfo, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo.AuthStatus
 */
export class LandingInfo_AuthStatus extends Message<LandingInfo_AuthStatus> {
  /**
   * @generated from field: uint32 attempts_count = 1;
   */
  attemptsCount = 0;

  /**
   * @generated from field: qliq_protobuf.apps.pc.AuthStrategy strategy = 2;
   */
  strategy = AuthStrategy.UNKNOWN_STRATEGY;

  /**
   * @generated from field: qliq_protobuf.apps.pc.AuthSecretRoute secret_routed_via = 3;
   */
  secretRoutedVia = AuthSecretRoute.UNKNOWN_ROUTE;

  constructor(data?: PartialMessage<LandingInfo_AuthStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo.AuthStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "attempts_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "strategy", kind: "enum", T: proto3.getEnumType(AuthStrategy) },
    { no: 3, name: "secret_routed_via", kind: "enum", T: proto3.getEnumType(AuthSecretRoute) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo_AuthStatus {
    return new LandingInfo_AuthStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo_AuthStatus {
    return new LandingInfo_AuthStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo_AuthStatus {
    return new LandingInfo_AuthStatus().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo_AuthStatus | PlainMessage<LandingInfo_AuthStatus> | undefined, b: LandingInfo_AuthStatus | PlainMessage<LandingInfo_AuthStatus> | undefined): boolean {
    return proto3.util.equals(LandingInfo_AuthStatus, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo.AuthOptions
 */
export class LandingInfo_AuthOptions extends Message<LandingInfo_AuthOptions> {
  /**
   * @generated from field: repeated qliq_protobuf.apps.pc.AuthStrategy available_strategies = 1;
   */
  availableStrategies: AuthStrategy[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.apps.pc.AuthSecretRoute available_routes = 2;
   */
  availableRoutes: AuthSecretRoute[] = [];

  constructor(data?: PartialMessage<LandingInfo_AuthOptions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo.AuthOptions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "available_strategies", kind: "enum", T: proto3.getEnumType(AuthStrategy), repeated: true },
    { no: 2, name: "available_routes", kind: "enum", T: proto3.getEnumType(AuthSecretRoute), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo_AuthOptions {
    return new LandingInfo_AuthOptions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo_AuthOptions {
    return new LandingInfo_AuthOptions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo_AuthOptions {
    return new LandingInfo_AuthOptions().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo_AuthOptions | PlainMessage<LandingInfo_AuthOptions> | undefined, b: LandingInfo_AuthOptions | PlainMessage<LandingInfo_AuthOptions> | undefined): boolean {
    return proto3.util.equals(LandingInfo_AuthOptions, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo.AuthRequest
 */
export class LandingInfo_AuthRequest extends Message<LandingInfo_AuthRequest> {
  /**
   * @generated from oneof qliq_protobuf.apps.pc.LandingInfo.AuthRequest.auth_state
   */
  authState: {
    /**
     * @generated from field: qliq_protobuf.apps.pc.LandingInfo.AuthOptions auth_options = 1;
     */
    value: LandingInfo_AuthOptions;
    case: "authOptions";
  } | {
    /**
     * @generated from field: qliq_protobuf.apps.pc.LandingInfo.AuthStatus auth_status = 2;
     */
    value: LandingInfo_AuthStatus;
    case: "authStatus";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: string continue_as_visitor_url = 3;
   */
  continueAsVisitorUrl = "";

  /**
   * @generated from field: string masked_email = 4;
   */
  maskedEmail = "";

  /**
   * @generated from field: string masked_phone_number = 5;
   */
  maskedPhoneNumber = "";

  constructor(data?: PartialMessage<LandingInfo_AuthRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo.AuthRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_options", kind: "message", T: LandingInfo_AuthOptions, oneof: "auth_state" },
    { no: 2, name: "auth_status", kind: "message", T: LandingInfo_AuthStatus, oneof: "auth_state" },
    { no: 3, name: "continue_as_visitor_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "masked_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "masked_phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo_AuthRequest {
    return new LandingInfo_AuthRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo_AuthRequest {
    return new LandingInfo_AuthRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo_AuthRequest {
    return new LandingInfo_AuthRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo_AuthRequest | PlainMessage<LandingInfo_AuthRequest> | undefined, b: LandingInfo_AuthRequest | PlainMessage<LandingInfo_AuthRequest> | undefined): boolean {
    return proto3.util.equals(LandingInfo_AuthRequest, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo.ErrorInfo
 */
export class LandingInfo_ErrorInfo extends Message<LandingInfo_ErrorInfo> {
  /**
   * @generated from field: qliq_protobuf.ApiErrorCode error_code = 1;
   */
  errorCode = ApiErrorCode.API_ERROR_UNKNOWN;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage = "";

  constructor(data?: PartialMessage<LandingInfo_ErrorInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo.ErrorInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "error_code", kind: "enum", T: proto3.getEnumType(ApiErrorCode) },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo_ErrorInfo {
    return new LandingInfo_ErrorInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo_ErrorInfo {
    return new LandingInfo_ErrorInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo_ErrorInfo {
    return new LandingInfo_ErrorInfo().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo_ErrorInfo | PlainMessage<LandingInfo_ErrorInfo> | undefined, b: LandingInfo_ErrorInfo | PlainMessage<LandingInfo_ErrorInfo> | undefined): boolean {
    return proto3.util.equals(LandingInfo_ErrorInfo, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.LandingInfo.AuthInfo
 */
export class LandingInfo_AuthInfo extends Message<LandingInfo_AuthInfo> {
  /**
   * @generated from field: qliq_protobuf.auth.Session auth_session = 1;
   */
  authSession?: Session;

  constructor(data?: PartialMessage<LandingInfo_AuthInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.LandingInfo.AuthInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_session", kind: "message", T: Session },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LandingInfo_AuthInfo {
    return new LandingInfo_AuthInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LandingInfo_AuthInfo {
    return new LandingInfo_AuthInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LandingInfo_AuthInfo {
    return new LandingInfo_AuthInfo().fromJsonString(jsonString, options);
  }

  static equals(a: LandingInfo_AuthInfo | PlainMessage<LandingInfo_AuthInfo> | undefined, b: LandingInfo_AuthInfo | PlainMessage<LandingInfo_AuthInfo> | undefined): boolean {
    return proto3.util.equals(LandingInfo_AuthInfo, a, b);
  }
}

